module.exports = __webpack_public_path__ + "static/media/lungs.d9542aea.svg";